import React, { useState, useEffect, useRef, useCallback, useSyncExternalStore } from 'react';
import './TestPage.css';

function Playground() {
  const [text, setText] = useState('a');        // 实时更新的状态
  const [debouncedText, setDebouncedText] = useState('a'); // 防抖后的状态
  const timerRef = useRef(null);

  // 用户输入时实时更新 text
  const handleChange = useCallback((e) => {
    setText(e.target.value);

    // 防抖更新 debouncedText
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setDebouncedText(e.target.value);
    }, 1000);
  }, []);

  // 清理定时器
  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  // 副作用依赖 debouncedText（而不是 text）
  useEffect(() => {
    function onTimeout() {
      console.log('⏰ ' + debouncedText);
    }

    console.log('🔵 Schedule "' + debouncedText + '" log');
    const timeoutId = setTimeout(onTimeout, 3000);

    return () => {
      console.log('🟡 Cancel "' + debouncedText + '" log');
      clearTimeout(timeoutId);
    };
  }, [debouncedText]); // 关键变化：依赖防抖后的值

  return (
    <>
      <label>
        What to log:{' '}
        <input
          value={text} // 绑定实时值
          onChange={handleChange}
        />
      </label>
      <h1>{text}</h1>
    </>
  );
}

// 1. 定义订阅函数（通知 React 数据变化）
const subscribe = (callback) => {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
};
// 2. 定义获取快照的函数（返回当前值）
const getSnapshot = () => window.innerWidth;
function SizeComponent() {
  // 3. 使用 Hook
  const width = useSyncExternalStore(
    subscribe,
    getSnapshot
  );
  return <div>Window width: {width}</div>;
}

function TestPage() {
  const [show, setShow] = useState(false);
  return (
    <div className="test-page">
      <h2>测试页面</h2>
      <div className="test-content">
        <button onClick={() => setShow(!show)}>
          {show ? 'Unmount' : 'Mount'} the component
        </button>
        {show && <hr />}
        {show && <Playground />}
      </div>
      <div className="container">
        <div className="left">左侧元素</div>
        <div className="right">右侧元素</div>
      </div>
      <SizeComponent />
    </div>
  );
}

export default TestPage; 